import styled from "styled-components";
import { DatePicker, DatePickerProps, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import Input from "antd/es/input/Input";

export const StyledInput = styled(Input)`
  border-radius: 3px;
  /* height: 48px; */
  /* border: 1px solid #000; */
  font-size: 14px;
  color: #333333;
  padding: 8px 12px;

  &:focus {
    border-color: #333;
  }

  &::placeholder {
    color: #6f6c90;
    font-size: 14px;
  }
`;
// Define the interface for the Label component's props.
interface LabelProps {
  fontWeight?: string; // fontWeight is optional here, with a default value.
}
// Styled Label component with `fontWeight` prop
export const Label = styled.label<LabelProps>`
  font-size: 15px !important;
  font-weight: ${(props) => props.fontWeight || "700"}; // Default to 700 if not provided
  color: #000000;
  margin-bottom: 4px;
  display: block;
`;

// Styled TextArea
export const StyledTextArea = styled(TextArea) <{ height?: string }>`
  width: 100%;
  height: ${(props) => props.height || "85px"}; /* Default to 85px if no height is passed */
  border: 1px solid #d9d9d9;
  font-size: 14px;
  padding: 12px;
  resize: vertical;

  &:focus {
    border-color: #002b7f;
    outline: none;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.25);
    font-size: 15px;
  }
`;
// Styled Date Input
export const StyledDateInput = styled(DatePicker) <DatePickerProps>`
  width: 100%;
  height: 40px;
  border: 1px solid #d9d9d9;
  font-size: 15px;
  color: #333333;
  padding: 7px 11px;
  appearance: none; /* Remove default browser styling for date input */

  &:focus {
    outline: none;
    border-color: #002b7f;
    // box-shadow: 0px 4px 16px rgba(0, 43, 127, 0.2);
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.25);
    font-size: 15px;
  }
`;
export const StyledFileUploadInput = styled.input`
  width: 100%;
  height: 48px;
  border: 1px solid #333;
  font-size: 14px;
  color: #333333;
  padding: 8px 12px;
  appearance: none; /* Remove default browser styling for date input */

  &:focus {
    border-color: #002b7f;
    // box-shadow: 0px 4px 16px rgba(0, 43, 127, 0.2);
  }

  &::placeholder {
    color: #6f6c90;
    font-size: 15px;
  }
`;

export const FileUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-upload.ant-upload-list-picture-card {
    margin: 0;
    background-color: #fff;
    border: none;
    height: auto;
  }

  .ant-upload.ant-upload-select {
    width: 100% !important;
    border: none !important;
    height: auto !important;
    background-color: transparent !important;
  }
`;

export const AddFileWrapper = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  gap: 4px;
  justify-content: flex-start;
  padding: 10px;
  width: 100%;
  border: 1px solid #d9d9d9;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;
